import { getImageBuilder } from '@/app/lib/media-helper';
import { getImageDimensions } from '@sanity/asset-utils';
import { stegaClean } from '@sanity/client/stega';
import { Image } from 'next-sanity/image';
import { normalizeAltText } from '@workspace/constants';

interface CoverImageProps {
  image: any;
  priority?: boolean;
}

export function CoverImage(props: CoverImageProps) {
  const { image: source, priority } = props;
  const image = source?.asset?._ref ? (
    <Image
      className="object-cover"
      width={getImageDimensions(source).width}
      height={getImageDimensions(source).height}
      alt={normalizeAltText(source?.bynderImage?.alt || stegaClean(source?.alt) || '')}
      src={getImageBuilder(source)?.url()}
      priority={priority}
    />
  ) : null;

  return <div className="relative">{image}</div>;
}
